"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_fs = require("fs");
var import_events = require("events");
var import_os = require("os");
var import_path = __toESM(require("path"), 1);
var import_vitest = require("vitest");
import_vitest.vi.mock("vite", async function() {
  var actual = await import_vitest.vi.importActual("vite");
  return {
    ...actual,
    createServerModuleRunner: import_vitest.vi.fn(function() {
      return {
        import: import_vitest.vi.fn()
      };
    })
  };
});
(0, import_vitest.describe)("createFileSystemRouterPlugin", function() {
  var previousVxrnVersion = globalThis["__vxrnVersion"];
  var previousIsVxrnCli = process.env.IS_VXRN_CLI;
  var previousViteEnvironment = process.env.VITE_ENVIRONMENT;
  var previousVxrnPluginConfig;
  var tempRoot;
  (0, import_vitest.beforeEach)(function() {
    previousVxrnPluginConfig = globalThis.__vxrnPluginConfig__;
  });
  (0, import_vitest.afterEach)(function() {
    if (tempRoot) {
      (0, import_fs.rmSync)(tempRoot, {
        recursive: true,
        force: true
      });
      tempRoot = void 0;
    }
    if (previousIsVxrnCli === void 0) {
      delete process.env.IS_VXRN_CLI;
    } else {
      process.env.IS_VXRN_CLI = previousIsVxrnCli;
    }
    if (previousViteEnvironment === void 0) {
      delete process.env.VITE_ENVIRONMENT;
    } else {
      process.env.VITE_ENVIRONMENT = previousViteEnvironment;
    }
    if (previousVxrnPluginConfig === void 0) {
      delete globalThis.__vxrnPluginConfig__;
    } else {
      ;
      globalThis.__vxrnPluginConfig__ = previousVxrnPluginConfig;
    }
    globalThis["__vxrnVersion"] = previousVxrnVersion;
    import_vitest.vi.restoreAllMocks();
  });
  (0, import_vitest.it)("keeps route watcher rebuild errors handled", async function() {
    process.env.IS_VXRN_CLI = "1";
    tempRoot = (0, import_fs.mkdtempSync)(import_path.default.join((0, import_os.tmpdir)(), "one-router-watch-"));
    var appDir = import_path.default.join(tempRoot, "app");
    (0, import_fs.writeFileSync)(import_path.default.join(tempRoot, "package.json"), "{}\n");
    (0, import_fs.mkdirSync)(appDir);
    (0, import_fs.writeFileSync)(import_path.default.join(appDir, "index.tsx"), "export default function Index() { return null }\n");
    globalThis.__vxrnPluginConfig__ = {
      web: {
        defaultRenderMode: "ssg"
      }
    };
    var { createRouteIndex } = await import("../../utils/routeIndex");
    var { createFileSystemRouterPlugin } = await import("./fileSystemRouterPlugin");
    var plugin = createFileSystemRouterPlugin({
      router: {
        root: appDir
      }
    }, createRouteIndex({
      routerRoot: appDir
    }));
    var watcherListener;
    var server = {
      environments: {
        ssr: {}
      },
      watcher: {
        addListener: import_vitest.vi.fn(function(event, listener) {
          if (event === "all") {
            watcherListener = listener;
          }
        }),
        on: import_vitest.vi.fn()
      }
    };
    plugin.configureServer(server);
    (0, import_vitest.expect)(watcherListener).toBeDefined();
    var warn = import_vitest.vi.spyOn(console, "warn").mockImplementation(function() {
    });
    delete globalThis.__vxrnPluginConfig__;
    if (!watcherListener) {
      throw new Error("Expected route watcher listener to be registered");
    }
    await (0, import_vitest.expect)(Promise.resolve(watcherListener("add", import_path.default.join(appDir, "new-route.tsx")))).resolves.toBeUndefined();
    (0, import_vitest.expect)(warn).toHaveBeenCalledWith(import_vitest.expect.stringContaining("[one] Failed to rebuild routes"), import_vitest.expect.any(Error));
  });
  (0, import_vitest.it)("does not install the node request middleware when a worker environment exists", async function() {
    process.env.IS_VXRN_CLI = "1";
    tempRoot = (0, import_fs.mkdtempSync)(import_path.default.join((0, import_os.tmpdir)(), "one-router-worker-"));
    var appDir = import_path.default.join(tempRoot, "app");
    (0, import_fs.writeFileSync)(import_path.default.join(tempRoot, "package.json"), "{}\n");
    (0, import_fs.mkdirSync)(appDir);
    (0, import_fs.writeFileSync)(import_path.default.join(appDir, "index.tsx"), "export default function Index() { return null }\n");
    globalThis.__vxrnPluginConfig__ = {
      web: {
        defaultRenderMode: "ssg"
      }
    };
    var { createRouteIndex } = await import("../../utils/routeIndex");
    var { createFileSystemRouterPlugin } = await import("./fileSystemRouterPlugin");
    var plugin = createFileSystemRouterPlugin({
      router: {
        root: appDir
      }
    }, createRouteIndex({
      routerRoot: appDir
    }));
    var use = import_vitest.vi.fn();
    var server = {
      environments: {
        ssr: {},
        worker: {
          moduleGraph: {
            getModuleById: import_vitest.vi.fn()
          }
        }
      },
      middlewares: {
        use
      },
      watcher: {
        addListener: import_vitest.vi.fn(),
        on: import_vitest.vi.fn()
      }
    };
    var installMiddlewares = plugin.configureServer(server);
    installMiddlewares();
    (0, import_vitest.expect)(use).not.toHaveBeenCalled();
  });
  (0, import_vitest.it)("caches dev ssg html until the module runner is invalidated", async function() {
    process.env.VITE_ENVIRONMENT = "ssr";
    tempRoot = (0, import_fs.mkdtempSync)(import_path.default.join((0, import_os.tmpdir)(), "one-router-ssg-cache-"));
    var appDir = import_path.default.join(tempRoot, "app");
    var routeFile = import_path.default.join(appDir, "index+ssg.tsx");
    (0, import_fs.writeFileSync)(import_path.default.join(tempRoot, "package.json"), "{}\n");
    (0, import_fs.mkdirSync)(appDir);
    (0, import_fs.writeFileSync)(routeFile, "export default function Index() { return null }\n");
    var { createServerModuleRunner } = await import("vite");
    var { createRouteIndex } = await import("../../utils/routeIndex");
    var { createFileSystemRouterPlugin } = await import("./fileSystemRouterPlugin");
    var { virtualEntryId } = await import("./virtualEntryConstants");
    var renderCount = 0;
    var render = import_vitest.vi.fn(async function() {
      return `<html><body>${++renderCount}</body></html>`;
    });
    var runner = {
      import: import_vitest.vi.fn(async function(id) {
        if (id === virtualEntryId) {
          return {
            default: {
              render
            }
          };
        }
        if (id === routeFile) {
          return {
            default: function() {
              return null;
            }
          };
        }
        return {};
      })
    };
    import_vitest.vi.mocked(createServerModuleRunner).mockReturnValue(runner);
    var middlewareHandlers = [];
    var watcherListeners = /* @__PURE__ */ new Map();
    var server = {
      environments: {
        ssr: {}
      },
      hot: {
        send: import_vitest.vi.fn()
      },
      middlewares: {
        use: import_vitest.vi.fn(function(handler) {
          middlewareHandlers.push(handler);
        })
      },
      watcher: {
        add: import_vitest.vi.fn(),
        addListener: import_vitest.vi.fn(function(event, listener) {
          watcherListeners.set(event, [
            ...watcherListeners.get(event) || [],
            listener
          ]);
        }),
        on: import_vitest.vi.fn(function(event, listener) {
          watcherListeners.set(event, [
            ...watcherListeners.get(event) || [],
            listener
          ]);
        })
      }
    };
    var plugin = createFileSystemRouterPlugin({
      router: {
        root: appDir
      },
      server: {
        loggingEnabled: false
      }
    }, createRouteIndex({
      routerRoot: appDir
    }));
    var installMiddlewares = plugin.configureServer(server);
    installMiddlewares();
    var routeMiddleware = middlewareHandlers.at(-1);
    if (!routeMiddleware) {
      throw new Error("Expected route middleware to be registered");
    }
    var handleRouteRequest = routeMiddleware;
    async function request(pathname) {
      var chunks = [];
      var req = Object.assign(new import_events.EventEmitter(), {
        aborted: false,
        complete: true,
        originalUrl: pathname,
        url: pathname,
        headers: {
          ":authority": "localhost",
          ":method": "GET"
        },
        method: "GET"
      });
      var res = Object.assign(new import_events.EventEmitter(), {
        destroyed: false,
        writableFinished: false,
        setHeader: import_vitest.vi.fn(),
        appendHeader: import_vitest.vi.fn(),
        writeHead: import_vitest.vi.fn(),
        write: import_vitest.vi.fn(function(chunk) {
          chunks.push(chunk);
        }),
        end: import_vitest.vi.fn(function() {
          res.writableFinished = true;
          res.emit("finish");
        })
      });
      var next = import_vitest.vi.fn(function(error) {
        if (error) {
          throw error;
        }
        throw new Error("Expected One router middleware to handle request");
      });
      await handleRouteRequest(req, res, next);
      (0, import_vitest.expect)(res.end).toHaveBeenCalled();
      return chunks.join("");
    }
    await (0, import_vitest.expect)(request("/")).resolves.toContain("<body>1</body>");
    await (0, import_vitest.expect)(request("/")).resolves.toContain("<body>1</body>");
    (0, import_vitest.expect)(render).toHaveBeenCalledTimes(1);
    var versionBeforeChange = globalThis["__vxrnVersion"];
    plugin.hotUpdate.call({
      environment: {
        name: "ssr",
        moduleGraph: {
          getModulesByFile: function() {
            return /* @__PURE__ */ new Set([
              {
                id: routeFile
              }
            ]);
          }
        }
      }
    }, {
      file: routeFile
    });
    await (0, import_vitest.expect)(request("/")).resolves.toContain("<body>2</body>");
    (0, import_vitest.expect)(render).toHaveBeenCalledTimes(2);
    (0, import_vitest.expect)(globalThis["__vxrnVersion"]).toBe((versionBeforeChange || 0) + 1);
  });
});
//# sourceMappingURL=fileSystemRouterPlugin.test.js.map
